"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactGoogleMapPicker = _interopRequireDefault(require("react-google-map-picker"));

var _reactGeocode = _interopRequireDefault(require("react-geocode"));

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DefaultZoom = 10;

var CheckIn = function CheckIn(_ref) {
  var config = _ref.config,
      setCoords = _ref.setCoords,
      onCloseHandler = _ref.onCloseHandler,
      currentLocation = _ref.currentLocation,
      height = _ref.height,
      currentAddress = _ref.currentAddress,
      setSelectedAddress = _ref.setSelectedAddress,
      onCheckinHandler = _ref.onCheckinHandler,
      locationLabel = _ref.locationLabel,
      okayButtonText = _ref.okayButtonText,
      cancelButtonText = _ref.cancelButtonText;

  var _useState = (0, _react.useState)(currentLocation),
      _useState2 = _slicedToArray(_useState, 2),
      location = _useState2[0],
      setLocation = _useState2[1];

  var _useState3 = (0, _react.useState)(DefaultZoom),
      _useState4 = _slicedToArray(_useState3, 2),
      zoom = _useState4[0],
      setZoom = _useState4[1];

  var _useState5 = (0, _react.useState)(currentAddress),
      _useState6 = _slicedToArray(_useState5, 2),
      address = _useState6[0],
      setaddress = _useState6[1];

  function handleChangeLocation(lat, lng) {
    setLocation({
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    }); //console.log("latitude "+lat , "longitude "+lng);

    var latlng = new window.google.maps.LatLng(lat, lng);
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      'latLng': latlng
    }, function (results, status) {
      if (status !== window.google.maps.GeocoderStatus.OK) {
        alert(status);
      }

      if (status == window.google.maps.GeocoderStatus.OK) {
        // console.log(results);
        var address = results[1].formatted_address;
        setaddress(address);
      }
    });
  }

  function handleChangeZoom(newZoom) {
    setZoom(newZoom);
  }

  var handleLocation = function handleLocation() {
    setCoords(location);
    setSelectedAddress(address);
    onCloseHandler();
    onCheckinHandler(location, address);
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactGoogleMapPicker.default, {
    defaultLocation: currentLocation,
    zoom: zoom,
    mapTypeId: "roadmap",
    style: {
      height: height
    },
    onChangeLocation: handleChangeLocation,
    onChangeZoom: handleChangeZoom,
    apiKey: config.API_KEY
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, locationLabel ? locationLabel : 'Current Location-'), address), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mt-1 d-flex justify-content-end"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 6,
    className: " d-flex justify-content-end"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "outline-danger",
    onClick: function onClick() {
      onCloseHandler();
    }
  }, cancelButtonText ? cancelButtonText : 'Cancel'), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "outline-primary",
    onClick: handleLocation,
    className: "mx-2"
  }, okayButtonText ? okayButtonText : 'OK'))));
};

var _default = CheckIn;
exports.default = _default;